import { render } from "./Radiobutton.vue?vue&type=template&id=0b42620e"
import script from "./Radiobutton.vue?vue&type=script&lang=js"
export * from "./Radiobutton.vue?vue&type=script&lang=js"

import "./Radiobutton.vue?vue&type=style&index=0&id=0b42620e&lang=css"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__